module.exports = __webpack_public_path__ + "static/media/cb.8f422733.svg";